export default __webpack_public_path__ + "static/communitybridge-blue-016616198afdc6cb26c4e73b57d2a722.webp";